import React, { useEffect } from "react";
import Form, { InputSection } from "../../components/Form";
import { Field, Formik } from "formik";
import { DropDown, DropDownOptionsProps } from "../../../../ui/DropDown";
import Input, { NumberInput } from "../../../../ui/Input";
import { parseDropdown } from "../../../../utils/parseDropdown";
import { get } from "../../../../utils/get";

interface IProps {
  kpiOptions?: any;
  values?: any;
  setFieldValue: any;
  setKpiType?: any;
}

const KpiParameters = ({ kpiOptions, values, setKpiType }: IProps) => {
  const optimisationOptions = [
    {
      value: "maximise",
      label: "maximise",
    },
    {
      value: "minimise",
      label: "minimise",
    },
  ];
  const scoreTypeOptions = [
    {
      value: "percent",
      label: "percent",
    },
    {
      value: "numeric",
      label: "numeric",
    },
  ];
  const kpiTypeOptions: DropDownOptionsProps = [
    { value: "leading", label: "leading" },
    { value: "lagging", label: "lagging" },
  ];
  const selectedKpi = kpiOptions.filter(
    (kpi) => kpi.id === get(values, "kpi.value")
  );

  const kpi_type = {
    value: get(selectedKpi[0], "kpi_type"),
    label: get(selectedKpi[0], "kpi_type"),
  };
  const score_type = {
    value: get(selectedKpi[0], "score_type"),
    label: get(selectedKpi[0], "score_type"),
  };

  const optimisation = {
    value: get(selectedKpi[0], "optimisation"),
    label: get(selectedKpi[0], "optimisation"),
  };

  useEffect(() => {
    if (get(selectedKpi[0], "score_type")) {
      setKpiType(get(selectedKpi[0], "score_type"));
    }
    return () => {};
  }, [selectedKpi, setKpiType]);

  const Validate = (value) => {
    let error;

    if (!value) {
      error = "Value required";
    }

    return error;
  };

  return (
    <Form>
      <InputSection>
        <Field
          name="kpi"
          placeholder="select kpi"
          dropdownLabel="KPI name"
          component={DropDown}
          validate={Validate}
          width="96%"
          options={parseDropdown(kpiOptions)}
          isBordered={true}
          value={get(values, "kpi")}
        />
      </InputSection>
      <InputSection>
        <Field
          name="notes"
          placeholder="description"
          label="Description"
          validate={Validate}
          type="textarea"
          component={Input}
          width="96%"
          height="6em"
          isBordered={true}
        />
      </InputSection>
      <Field
        type="text"
        name="weight"
        validate={Validate}
        placeholder="enter weight"
        label="Weight"
        width="87%"
        component={Input}
      />
      <Field
        name="target"
        placeholder="enter target"
        validate={Validate}
        label="Target"
        width="87%"
        value={values.target}
        component={NumberInput}
      />

      <Field
        name="optimisation"
        dropdownLabel="Optimization"
        validate={Validate}
        component={DropDown}
        options={optimisationOptions}
        isBordered={true}
        width="18em"
        backgroundColor="#F5F6FB"
        value={get(values, "optimisation")}
        isDisabled    />
      <Field
        name="kpi_type"
        dropdownLabel="Type"
        component={DropDown}
        options={kpiTypeOptions}
        validate={Validate}
        isBordered={true}
        width="18em"
        backgroundColor="#F5F6FB"
        value={get(values, "kpi_type")}
        isDisabled
      />
      <Field
        name="score_type"
        dropdownLabel="Data Type"
        component={DropDown}
        validate={Validate}
        width="18em"
        options={scoreTypeOptions}
        isBordered={true}
        backgroundColor="#F5F6FB"
        value={get(values, "score_type")}
        isDisabled
      />
    </Form>
  );
};

export default KpiParameters;
